<template>
    <div class="loan-calculator">
	    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
	      <atom-spinner
	        v-if="loading"
	        :animation-duration="speed"
	        :size="config.size"
	        :color="spinnersColor"
	      />
	    </div>
	    <div class="row">
	      	<div class="flex xs12 md12 xl12">
	      	 	<va-card>
              <template #header>
            {{ $t('Loans Calculator') }}
          </template>
	          		<form @submit.prevent="onsubmit">
			            <va-select
			              class="mb-4"
			              label="Product"
			              v-model="product_id"
                    searchable
			              textBy="product_name"
			              :loading = "loadSelect"
			              :options="loans"
			              key-by="product_id"
                    @input="setSelected"
			            />

			            <va-input
			              :label="$t('amount')"
			              type="number"
			              v-model="formdata.amount"
			              :error="!!amountErrors.length"
			              :error-messages="amountErrors"
			            />

                  

                  <va-date-picker 
                      :label="$t('forms.dateTimePicker.start_date')"
                      :config="{
                        locale: {firstDayOfWeek: 1},
                        inline: false,
                        position:'below',
                        altInput:true,
                        minDate:today,
                        maxDate:SixMonthsToCome
                      }"
                      v-model="date"
                  />

                  <va-date-picker
                      v-if = "showEndDate" 
                      :label="$t('forms.dateTimePicker.end_date')"
                      :config="{
                        locale: {firstDayOfWeek: 1},
                        inline: false,
                        position:'below',
                        altInput:true,
                        minDate:today,
                        maxDate:MaxendDate
                      }"
                      v-model="end_date"
                      @input="setnewendDate"
                  />
                  <va-input
                    :label="$t('period-months')"
                    type="number"
                    v-model="this.newPeriod"
                    :readonly = "true"                   
                  />

                  <va-input
                    :label="$t('interest %')"
                    type="number"
                    v-model="this.newInterest"
                    :readonly = "true"                     
                  />
                  <div class="row mt-5">            
                    <va-button type="submit" >
                        {{ $t('forms.controls.submit') }}
                    </va-button>                        
                  </div>
	          		</form>
	       		</va-card>
	   		</div>
        <div class="flex xs12 md12 xl12" v-if="showtable">         
            <va-card>
              <template #header>
            {{ $t('loans.guaranteed_loans') }}
          </template>
                <div class="row align--center mb-1">
                  <div class="flex xs12 sm6">
                    <va-input
                      class="ma-0"
                      :value="term"
                      :placeholder="$t('tables.searchByName')"
                      @input="search"
                      removable
                    >
                      <va-icon name="fa fa-search" slot="prepend" />
                    </va-input>
                  </div>
                </div>

                <va-data-table
                  :fields="mode ? detailedFields : fields"
                  :data="filteredData"
                  :loading="loading"
                  hoverable
                  no-pagination
                >
                  <template v-slot:installment_no="props">
                    {{ props.rowData.installment_no }}
                  </template>
                  <template v-slot:date="props">
                    {{ props.rowData.date | formatDate }}
                  </template>
                  <template v-slot:repayment_year="props">
                    {{ props.rowData.repayment_year }}
                  </template>
                  <template v-slot:payment_amount="props">
                    <div style="text-align: right;">{{ props.rowData.payment_amount | Currency }}</div>
                  </template>
                  <template v-slot:interest="props">
                    <div style="text-align: right;">{{ props.rowData.interest | Currency }}</div>
                  </template>
                  <template v-slot:principle="props">
                    <div style="text-align: right;">{{ props.rowData.principle | Currency }}</div>
                  </template>
                  <template v-slot:loan_balance="props">
                    <div style="text-align: right;">{{ props.rowData.loan_balance | Currency }}</div>
                  </template>
                </va-data-table>
              </va-card>         
        </div>
		</div>
    </div>
</template>
<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
import debounce from 'lodash/debounce'

export default {
  components: {
    ...spinners      
  },
  name: 'loan-calculator',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
      term:'',
      mode: 0,
      showtable:false,
      loans: [
        {
          product_id: '',
          product_name: 'select an Option',
        }
      ],
      schedule:{},
      loading: false,
      loadSelect:false,
      date:'',
      newPeriod:'',
      end_date:'',
      newInterest:'',
      interest:'',
      formdata:{                
        amount:''
      },
      SixMonthsToCome:'',
      showEndDate:'',
      MaxendDate:'',
      today:'',
      product_id:'',
      interest:'',
      amountErrors : [],
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    fields () {
      return [{
        name: '__slot:installment_no',
        title: this.$t('tables.headings.installment_no'),
        sortField: 'installment_no',
      },
      {
        name: '__slot:date',
        title: this.$t('tables.headings.date'),       
        sortField: 'date',
      }, 
      {
        name: '__slot:repayment_year',
        title: this.$t('tables.headings.repayment_year'),       
        sortField: 'repayment_year',
      }, 
      {
        name: '__slot:payment_amount',
        title: this.$t('tables.headings.payment_amount'),       
        sortField: 'payment_amount',
      }, 
      {
        name: '__slot:interest',
        title: this.$t('tables.headings.interest'),       
        sortField: 'interest',
      },
      {
        name: '__slot:principle',
        title: this.$t('tables.headings.principle'),       
        sortField: 'principle',
      },
      {
        name: '__slot:loan_balance',
        title: this.$t('tables.headings.loan_balance'),       
        sortField: 'loan_balance',
      }]
    },
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    formReady () {
      return !this.amountErrors.length
    },

    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.schedule
      }
      return this.schedule.filter(item => {
        return item.date.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods : {
    
    GetProduct(id) {      
      return this.loans.filter(item => item.product_id.toLowerCase() === this.id.toLowerCase());      
    },
    onsubmit (e) {
      e.preventDefault();
    	this.amountErrors = this.formdata.amount ? [] : ['Amount is required']

      console.log(parseInt(this.formdata.amount))
      console.log(parseInt(this.product_id.max_amount))
      console.log(parseInt(this.product_id.min_amount))
      this.amountErrors = (parseInt(this.formdata.amount) > parseInt(this.product_id.max_amount))  ? [`Amount exceeds the maximum loan limit of ${this.product_id.max_amount}`] : []
      this.amountErrors =  (parseInt(this.formdata.amount) < parseInt(this.product_id.min_amount)) ?[`Amount is below the minimum loan limit of ${this.product_id.min_amount}`] : []

      if (this.formReady) { 
        this.isLoading=true
        const form = {
          
          product: this.product_id,
          user_id: this.userData.user_id,
          amount: this.formdata.amount,
          start_date: this.date,
          period : this.newPeriod,
        };

        this.loading = true
        const self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${self.$apiUrl}GetLoanSchedule`, form, config)
        .then(function (res) {          
            self.loading = false
            self.showtable = true
            res = res.data.result           
            self.schedule = res.slice()
            console.log(res)
            self.interest=res.totalInterest
            console.log(self.interest)
        })
        .catch(function (error) {
            console.log(error)
        })
      }       
    },

    GetLoanProducts () {
      this.loadSelect = true
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      axios.post(`${self.$apiUrl}GetLoanProducts`, self.userData.user_id, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.loans = res
      })
      .catch(function (error) {
          console.log(error)
      })
    },

    setSelected(value){      
      this.newInterest = value.interest_rate
      this.showEndDate = true;
      this.MaxendDate = this.$options.filters.createDate(0,+value.repayment_period,0)
      this.MaxendDate = this.$options.filters.dateToYMD(this.MaxendDate)
      this.end_date = this.MaxendDate
      this.newPeriod =  value.repayment_period           
    },

    setnewendDate(value){
      
      this.newPeriod = this.$options.filters.DateDiff(this.date, value)
    },

    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  created () {  
    this.GetLoanProducts()
    this.today  = this.$options.filters.dateToYMD(new Date());
    this.date = this.today 
    this.SixMonthsToCome = this.$options.filters.createDate(0,+6,0)
    this.SixMonthsToCome = this.$options.filters.dateToYMD(this.SixMonthsToCome)  	
  }
}
</script>